import styled from "styled-components";

const LessonOverviewContainer = styled.div``;

export {
  LessonOverviewContainer
}